import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FeedProfile } from '@vestiaire/api-sdk-angular';
import { FeedCardsService } from '@app/+feed/service/feed-cards.service';
import { ImagesService } from '@app/shared/components/images/services/images.service';

export interface ISeeMemberEvent {
  emitter: 'button' | 'link';
  profileId?: string;
  trackingKey?: string;
}

@Component({
  selector: 'vc-feed-card-profile',
  templateUrl: './feed-card-profile.component.html',
  styleUrls: ['./feed-card-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedCardProfileComponent implements OnInit {
  @Input() profile: FeedProfile;
  @Input() cardType: string;
  avatarSrc: string;
  feedType = 'default';
  justBeenFollowed = false;

  @Output() followMemberFeed = new EventEmitter<FeedProfile>();
  @Output() seeMember = new EventEmitter<ISeeMemberEvent>();

  constructor(private feedService: FeedCardsService) {
    this.feedType = this.feedService.feedType;
  }

  ngOnInit() {
    this.avatarSrc = ImagesService.buildUrl(
      `/profil/${this.profile.describes.picture ? this.profile.describes.picture : 'missing_avatar.gif'}`
    );
  }

  toFollow() {
    this.justBeenFollowed = true;
    this.profile.isFollowed = true;
    this.followMemberFeed.emit(this.profile);
  }
}
